import {subscriberAccounts, subscriberFundAccounts} from './accounts/subscription';
import {subscriberAssets} from './assets/subscription';
import {subscriberNotificationOrder} from './notification-order/subscription';
import {subscriberOrdersActive} from './orders-active/subscription';
import {subscriberOrdersConditional} from './orders-conditional/subscription';
import {subscriberOrdersFill} from './orders-fill/subscription';
import {subscriberOrdersHistory} from './orders-history/subscription';

export function subscribeMarginTrade() {
  subscriberAccounts();
  subscriberFundAccounts();
  subscriberAssets();
  subscriberNotificationOrder();
  subscriberOrdersActive();
  subscriberOrdersConditional();
  subscriberOrdersFill();
  subscriberOrdersHistory();
}
